import angular from 'angular';

(function () {
    'use strict';
    angular.module('app.core').factory('Attachment', AttachmentData);

    /* @ngInject */
    function AttachmentData(logger, CONF, UtilSvc) {
        Attachment.prototype = {
            build: build,
            getDownloadLink: getDownloadLink,
            isOriginal: isOriginal,
            isProofDiary: isProofDiary,
            isMetaAttachment: isMetaAttachment,
        };

        function Attachment(attachmentData) {
            if (attachmentData) {
                this.build(attachmentData);
            }
        }

        return Attachment;

        /////////////////////

        function build(attachmentData) {
            this.invoiceGuid = attachmentData.invoiceGuid || null;
            this.fileHeaderId = attachmentData.fileHeaderId || null;
            this.attachmentId = attachmentData.file_identifier || null;
            this.typeDoc = _initType(attachmentData.type);
            this.fileName = attachmentData.file_name || null;
            this.size = attachmentData.file_size || null;
            this.creationDate = UtilSvc.parseDate(attachmentData.date);
            this.$valid = true;
        }

        function _initType(typeDoc) {
            if (typeDoc) {
                return angular.uppercase(typeDoc);
            }
            return null;
        }

        function getDownloadLink() {
            if (this.invoiceGuid && this.attachmentId) {
                return (
                    CONF.appContext +
                    CONF.apiBaseUrl +
                    CONF.apiVersion +
                    '/invoices/' +
                    this.invoiceGuid +
                    '/attachment/' +
                    this.attachmentId
                );
            } else if (this.attachmentId) {
                return (
                    CONF.appContext +
                    CONF.apiBaseUrl +
                    CONF.apiVersion +
                    '/invoices/upload/attachment/' +
                    this.attachmentId
                );
            } else if (this.fileHeaderId) {
                return CONF.appContext + CONF.apiBaseUrl + CONF.apiVersion + '/staged-files/' + this.fileHeaderId;
            }
            return null;
        }

        function isOriginal() {
            return this.typeDoc === 'INVOICE_PDF';
        }

        function isProofDiary() {
            return this.typeDoc === 'PROOF_DIARY';
        }

        function isMetaAttachment() {
            return ['INVOICE_PDF', 'INVOICE_XML'].indexOf(this.typeDoc) !== -1;
        }
    }
})();
